const capitalizeWord = (word) => {
  // List of known acronyms and words that should remain uppercase or have specific capitalization
  const specialCases = {
    'KIPP': 'KIPP',
    'IDEA': 'IDEA',
    'DSST:': 'DSST:',
    'STRIVE': 'STRIVE',
    'ISD': 'ISD',
    'STEM': 'STEM',
    'PK': 'PK',
    'PRE-K': 'Pre-K',
    'K-8': 'K-8',
    'K-12': 'K-12',
    '3D': '3D',
  };
  
  if (specialCases[word.toUpperCase()]) {
    return specialCases[word.toUpperCase()];
  }
  
  // List of lowercase words (articles, conjunctions, prepositions)
  const lowercaseWords = ['a', 'an', 'the', 'and', 'but', 'or', 'for', 'nor', 'on', 'at', 'to', 'from', 'by', 'of'];
  
  if (lowercaseWords.includes(word.toLowerCase())) {
    return word.toLowerCase();
  }
  
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

const formatSchoolName = (name) => {
  if (!name || typeof name !== 'string') {
    return name || ''; // Return empty string if name is undefined/null
  }
  return name
    .split(' ')
    .map((word, index) => {
      // Always capitalize the first and last word, regardless of what they are
      if (index === 0 || index === name.split(' ').length - 1) {
        return capitalizeWord(word);
      }
      return capitalizeWord(word);
    })
    .join(' ');
};

export { formatSchoolName, capitalizeWord };